var map = {
	"./Music.jpg": 6180,
	"./animals.webp": 6963,
	"./boardGame.jpg": 9822,
	"./books.jpg": 1351,
	"./cartoonAnim.jpg": 9750,
	"./celebrity.webp": 8606,
	"./computer.webp": 3888,
	"./film.jpg": 8900,
	"./gadgets.webp": 6087,
	"./general-knowledge.png": 8821,
	"./geography.png": 3697,
	"./history.jpg": 7399,
	"./jap.jpg": 9020,
	"./mathematics.jpg": 5443,
	"./musical&theater.webp": 8110,
	"./mythodology.jpg": 2601,
	"./politics.jpg": 2782,
	"./scienceNature.jpg": 9196,
	"./sport.webp": 6762,
	"./television.png": 7837,
	"./vehicles.jpg": 5345,
	"./videoGame.jpg": 6800
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6486;